import { React } from "react";

import { useTranslation } from 'react-i18next';

const TextoProtocolos = ({protocolos, ruta}) => {
	
	const { t } = useTranslation();

	var imagen = "/images/web/bedloop-nofoto.png"; 

	if (protocolos.imagen_cabecera)
	{
		imagen = ruta+"/"+protocolos.imagen_cabecera;
	}

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="imatge-banner" title={t("Protocolos")} style={{  backgroundImage: "url('"+imagen+"')", backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center', backgroundSize: "cover"}} >
                        </div>
                        <h1 className="noticia-individual mt-5 mb-5">{ t("Protocolos") }</h1>
                        <div className="noticia-individual-descripcio-llarga mb-5" dangerouslySetInnerHTML={{__html: protocolos.ladesc}}></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TextoProtocolos;